import map from '../map';
import types, {getTypesObject, typesObj} from '../types';
import {calculateVisibleAreas} from '../area';
import {formatYearsDataArray, getEmptyYearDataObject} from '../years';
import debounce from 'lodash.debounce';

/**
 * query map layers and do any processing/calculations needed
 */
export default function queryLayers() {

    // build an object first, then organize into array
    let dataObject = getEmptyYearDataObject();
    let areas = getTypesObject();

    // query all type layers
    let allLayers = types.map(function(t){ return t.name; });
    let features = map.queryRenderedFeatures({layers: allLayers});

    for (let i = 0, numFeatures = features.length; i < numFeatures; i++) {
        // build an object with year keys and store layer type totals by year
        let y = features[i].properties.y, // year
            a = features[i].properties.a, // change attribution
            layerName = typesObj[a].name; // layer name

        // increment totals in year object
        dataObject[y][layerName]++;

        // add up total areas
        areas[layerName]++;
    }

    // format data object into array for d3
    formatYearsDataArray(dataObject);

    // calculate visible area for one layer and update the vue model
    calculateVisibleAreas(areas);

    // trigger the chart updates
    map.fire('yearsData.updated');
    map.fire('loading.end');
}

// recalculate areas and years on map interaction
let queryLayersDebounced = debounce(queryLayers, 250);
map.on('render', function() {
    map.fire('loading.start');
    queryLayersDebounced();
});



// WEBPACK FOOTER //
// ./src/js/mapQuery/mapQuery.js